import React from 'react';
import {useLocation, useNavigate} from "react-router-dom";
import {useFeatureToggles} from "@/hooks/useFeatureToggles";
import {useAuthStore} from "@/store/auth_store";
import PermissionsHelpers from "@/helpers/permissions_helpers";
import ApplicationMenu from "@/components/navigation/ApplicationMenu";
import {NavItem as RemedyNavItem, NavRail as RemedyNavRail} from "patient-ping-remedy/packages/navigation-rail";
import {FeatureToggle} from "@/api/dto/dto";
import {AppRole, Feature, FeatureNew, FeaturePermissionLevel} from "@/api/dto/permissions";

const NavRail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { checkBooleanToggle } = useFeatureToggles();
  const { currentUser } = useAuthStore((state) => ({ currentUser: state.currentUser }));

  const isNewPermissionsEnabled = checkBooleanToggle(FeatureToggle.CARECO_3415_NEW_USER_PERMISSIONS);

  if(!currentUser) return null;

  return (
    <RemedyNavRail
      route={location.pathname}
      appMenu={<ApplicationMenu />}
      onItemClick={(route) => navigate(route)}
    >
      <RemedyNavItem
        routes={['/clients', /^\/clients\/profile(\/.*)?$/, '/']}
        text={'Clients'}
        iconClass={'user'}
      />
      {
        (isNewPermissionsEnabled ?
          PermissionsHelpers.canForUserFeaturePermissionNew(currentUser,
            FeaturePermissionLevel.VIEW,
            FeatureNew.TASKS
          ) : PermissionsHelpers.canForUserFeaturePermission(currentUser,
            FeaturePermissionLevel.VIEW,
            Feature.TASKS
          )) &&
        <RemedyNavItem
          routes={['/tasks', /^\/tasks(\/.*)?$/]}
          text={'Tasks'}
          iconClass={'check-square'}
        />
      }
      {
        (PermissionsHelpers.isBamboo(currentUser) ||
          (isNewPermissionsEnabled ? (
            PermissionsHelpers.canForUserFeaturePermissionNew(currentUser,
              FeaturePermissionLevel.VIEW,
              FeatureNew.MY_NETWORK
            )
            || PermissionsHelpers.canForUserFeaturePermissionNew(currentUser,
              FeaturePermissionLevel.VIEW,
              FeatureNew.NETWORK_REGISTRY_BROWSER
            )
            || PermissionsHelpers.canForUserFeaturePermissionNew(currentUser,
              FeaturePermissionLevel.VIEW,
              FeatureNew.NETWORK_FACILITIES_UNITS
            ))
            : PermissionsHelpers.canForUserFeaturePermission(currentUser,
              FeaturePermissionLevel.VIEW,
              Feature.NETWORK_REGISTRY
            ))) &&
            <RemedyNavItem
              routes={['/network_registry', /^\/network_registry(\/.*)?$/]}
              text={'Network registry'}
              iconClass={'address-book'} />
      }
      {
        (PermissionsHelpers.isBamboo(currentUser) ||
          (isNewPermissionsEnabled ?
            PermissionsHelpers.canForUserFeaturePermissionNew(currentUser,
              FeaturePermissionLevel.VIEW,
              FeatureNew.REFERRALS
            ) : PermissionsHelpers.canForUserFeaturePermission(currentUser,
              FeaturePermissionLevel.VIEW,
              Feature.REFERRALS
            ))) &&
            <RemedyNavItem
              routes={['/referrals', /^\/referrals(\/.*)?$/]}
              text={'Referrals'}
              iconClass={'handshake'}/>
      }
      {
        checkBooleanToggle(FeatureToggle.ANALYTICS_TAB) &&
        (isNewPermissionsEnabled ?
          PermissionsHelpers.canForUserFeaturePermissionNew(currentUser,
            FeaturePermissionLevel.VIEW,
            FeatureNew.ANALYTICS
          ) : PermissionsHelpers.canForUserFeaturePermission(currentUser,
            FeaturePermissionLevel.VIEW,
            Feature.USER_REPORTING
          )) &&
        <RemedyNavItem
          routes={['/analytics', /^\/analytics(\/.*)?$/]}
          text={'Analytics'}
          iconClass={'analytics'}
        />
      }
      {
        (isNewPermissionsEnabled ?
          PermissionsHelpers.canForUserFeaturePermissionNew(currentUser,
            FeaturePermissionLevel.VIEW,
            FeatureNew.ADMIN_MANAGEMENT
          ) : PermissionsHelpers.canForUserFeaturePermission(currentUser,
            FeaturePermissionLevel.VIEW,
            Feature.USER_PERMISSIONS
          )) &&
        <RemedyNavItem
          routes={['/admin', /^\/admin(\/.*)?$/]}
          text={'Admin'}
          iconClass={'cogs'}
        />
      }
      {
        currentUser?.role?.toUpperCase().includes(AppRole.BAMBOO_ADMIN) &&
        <RemedyNavItem
          routes={['/settings', /^\/settings(\/.*)?$/]}
          text={'Settings'}
          iconClass={'cog'}
        />
      }
      {
        currentUser?.role?.toUpperCase().includes(AppRole.BAMBOO_ADMIN) &&
        <RemedyNavItem
          routes={['/tools', /^\/tools(\/.*)?$/]}
          text={'Tools'}
          iconClass={'tools'}
        />
      }
    </RemedyNavRail>
  );
};

export default React.memo(NavRail);
